import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SparkApi from "../../api/SparkApi";

const CreateProductCategoryModal = (props) => {
  const [productCategoryRecord, setProductCategoryRecord] = useState();

  useEffect(() => {
    if (props.recordForUpdate) {
      setProductCategoryRecord(props.recordForUpdate);
    } else {
      setProductCategoryRecord({
        status: "active",
      });
    }
  }, [props.recordForUpdate]);

  const handleChange = (e) => {
    setProductCategoryRecord((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const recordSaveSuccefully = () => {
    props.onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (productCategoryRecord?.category) {
        if (productCategoryRecord?.id) {
          const updatedProductCategoryResult =
            await SparkApi.saveProductCategory(productCategoryRecord);

          if (updatedProductCategoryResult.success) {
            toast.success("Category updated successfully");
            setProductCategoryRecord({
              category: "",
              status: "active",
            });
            recordSaveSuccefully();
          } else {
            toast.error(updatedProductCategoryResult.message);
          }
        } else {
          const createProductCategoryResult = await SparkApi.createProductCategory(productCategoryRecord);
          if (createProductCategoryResult) {
            toast.success("Category create successfully");
            setProductCategoryRecord({
              category: "",
              status: "active",
            });
            recordSaveSuccefully();
          }
        }
      } else {
        return toast.error("Please fill all required fields");
      }
    } catch (error) {
      toast.error("Internel Server Error");
    }
  };


  return (
    <Modal
      show={props.show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={props?.onHide} className="view-form-header" centered>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.recordForUpdate?.category
            ? "Edit Product Category"
            : "Create  Product Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row className="mb-3">
            <Col lg={6}>
              <Form.Group className="mx-3" controlId="formBasicName">
                <Form.Label>Category Name</Form.Label>
                <Form.Control
                  required
                  style={{ height: "36px" }}
                  type="text"
                  name="category"
                  placeholder="Enter Category Name"
                  value={productCategoryRecord?.category}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col lg={6}>
              <Form.Group className="mx-3" controlId="formBasicSelect">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={productCategoryRecord?.status}
                  onChange={handleChange}
                  style={{ height: "36px" }}
                >
                  <option value="" disabled>
                    --Select status--
                  </option>
                  <option value="active" selected>
                    Active
                  </option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success btn-sm" onClick={handleSubmit}>
          {props?.recordForUpdate?.id ? "Update" : "Save"}
        </Button>
        <Button
          onClick={() => {
            setProductCategoryRecord({
              category: "",
              status: "",
            });
            props.onHide();
          }}
          variant="light btn-sm"
        >
          Close
        </Button>
      </Modal.Footer>
      {/* <ToastContainer position="top-center" autoClose={1500} theme="light" /> */}
    </Modal>
  );
};

export default CreateProductCategoryModal;
